// eslint-disable-next-line no-unused-vars
import {
  useImperativeHandle,
  forwardRef,
  useEffect,
  useCallback,
  Fragment,
  useState,
} from "react";
import { Modal, ModalBody } from "reactstrap";
import Container from "../../../../../components/base/Container/Container";
import { useAsync } from "../../../../../hooks";
import "./style.scss";
import { Icon, Paper, Typography } from "@mui/material";
import { Skeleton } from "@mui/lab";
import { Col, Row } from "reactstrap";
import { ModalHeader } from "../../../../../components/modal";
import { FontAwesome } from "../../../../../components/icon";
import DangKyPhatBieusEndpoint from "../../../../../service/Meet/DangKyPhatBieusEndpoint";
import { compare, ListenAudio } from ".";
import { formatDatetime } from "../../../../../actions/util";

const ListAudio = forwardRef(
  ({ isOpen, onClose, khungNoiDungId, thamDus }, ref) => {
    const [phatBieus, setPhatBieus] = useState([]);

    const getDangKyPhatBieu = useCallback(async () => {
      const { value: phatBieus } = await DangKyPhatBieusEndpoint.getDKPBOfMe(
        khungNoiDungId,
        thamDus.userThamDu?.id,
      );
      phatBieus.sort(compare);
      phatBieus.forEach((pb, i, arr) => {
        const {
          thanhPhanThamDu: { nhanSu, khachMoi },
          ...data
        } = pb;
        arr[i] = {
          ...data,
          userId: nhanSu ? nhanSu.userId : khachMoi?.userId,
          nhanSuId: nhanSu?.id,
          khachMoiId: khachMoi?.id,
        };
      });
      setPhatBieus(phatBieus);
    }, [khungNoiDungId, thamDus]);

    const { execute, status } = useAsync(getDangKyPhatBieu);

    useImperativeHandle(ref, () => ({}), []);

    useEffect(() => {
      if (isOpen) {
        execute();
      }
    }, [execute, isOpen]);

    return (
      <Modal
        size="sm"
        toggle={onClose}
        isOpen={isOpen ? true : false}
        zIndex="1500"
      >
        <ModalHeader toggle={onClose}>
          <FontAwesome fa="list" className="mr-2"></FontAwesome>
          Danh sách phát biểu (Cá nhân)
        </ModalHeader>
        <ModalBody className="pb-1">
          <Container
            className="p-1"
            style={{ height: "calc(100vh - 12rem)", overflow: "auto" }}
          >
            {status === "pending" ? (
              <Fragment>
                {Array.from(Array(5).keys()).map((cur, i) => (
                  <Row key={"ske13" + i} className="m-1 mb-3">
                    <Col md="5">
                      <Typography component="div" variant={"body1"}>
                        <Skeleton variant="rectangular" />
                      </Typography>
                    </Col>
                    <Col md={"7"}>
                      <Typography component="div" variant={"body1"}>
                        <Skeleton variant="rectangular" />
                      </Typography>
                    </Col>
                  </Row>
                ))}
              </Fragment>
            ) : (
              <Fragment>
                {phatBieus.length > 0 ? (
                  <Fragment>
                    {phatBieus.map((f, i) => {
                      return (
                        <Paper className="mb-2 mr-2 p-2" elevation={1}>
                          <div className="d-flex justify-content-between">
                            <div
                              className={`badge bg-green-lt d-flex align-items-center`}
                              style={{ width: "14rem" }}
                            >
                              <Icon>access_time</Icon>
                              {formatDatetime(f.phatBieuTai)}
                            </div>
                            {f.path && (
                              <ListenAudio
                                style={{ height: "2rem" }}
                                path={f.path}
                              />
                            )}
                          </div>
                        </Paper>
                      );
                    })}
                  </Fragment>
                ) : (
                  <Typography variant="h6">Chưa có dữ liệu</Typography>
                )}
              </Fragment>
            )}
          </Container>
        </ModalBody>
      </Modal>
    );
  },
);
export default ListAudio;
